/**
 * DealCouponz-style locale config: path prefix, label, flag (emoji), countryCode (for flag image).
 * Used by client routing, language switcher, and (server-side) sitemap.
 * Flag images: https://flagcdn.com/w40/{countryCode}.png
 */
export const DEFAULT_LOCALE = {
  code: 'en-US',
  pathPrefix: '',
  label: 'United States',
  languageLabel: 'English (US)',
  flag: '🇺🇸',
  countryCode: 'us',
};

export const LOCALES = [
  DEFAULT_LOCALE,
  { code: 'en-GB', pathPrefix: 'uk', label: 'United Kingdom', languageLabel: 'English (UK)', flag: '🇬🇧', countryCode: 'gb' },
  { code: 'en-AU', pathPrefix: 'au', label: 'Australia', languageLabel: 'English (AU)', flag: '🇦🇺', countryCode: 'au' },
  { code: 'ga-IE', pathPrefix: 'ga', label: 'Ireland', languageLabel: 'Irish', flag: '🇮🇪', countryCode: 'ie' },
  { code: 'de-DE', pathPrefix: 'de', label: 'Germany', languageLabel: 'Deutsch', flag: '🇩🇪', countryCode: 'de' },
  { code: 'de-AT', pathPrefix: 'at', label: 'Austria', languageLabel: 'Deutsch (AT)', flag: '🇦🇹', countryCode: 'at' },
  { code: 'es-ES', pathPrefix: 'es', label: 'Spain', languageLabel: 'Español', flag: '🇪🇸', countryCode: 'es' },
  { code: 'it-IT', pathPrefix: 'it', label: 'Italy', languageLabel: 'Italiano', flag: '🇮🇹', countryCode: 'it' },
  { code: 'fr-FR', pathPrefix: 'fr', label: 'France', languageLabel: 'Français', flag: '🇫🇷', countryCode: 'fr' },
  { code: 'pt-PT', pathPrefix: 'pt', label: 'Portugal', languageLabel: 'Português', flag: '🇵🇹', countryCode: 'pt' },
  { code: 'nl-NL', pathPrefix: 'nl', label: 'Netherlands', languageLabel: 'Nederlands', flag: '🇳🇱', countryCode: 'nl' },
  { code: 'no-NO', pathPrefix: 'no', label: 'Norway', languageLabel: 'Norsk', flag: '🇳🇴', countryCode: 'no' },
  { code: 'fi-FI', pathPrefix: 'fi', label: 'Finland', languageLabel: 'Suomi', flag: '🇫🇮', countryCode: 'fi' },
  { code: 'da-DK', pathPrefix: 'da', label: 'Denmark', languageLabel: 'Dansk', flag: '🇩🇰', countryCode: 'dk' },
  { code: 'sv-SE', pathPrefix: 'sv', label: 'Sweden', languageLabel: 'Svenska', flag: '🇸🇪', countryCode: 'se' },
];

/** Path prefixes that are valid for /:localePrefix/... routes (excluding default). */
export const LOCALE_PATH_PREFIXES = LOCALES.filter((l) => l.pathPrefix).map((l) => l.pathPrefix);

export function getLocaleByPathPrefix(prefix) {
  if (!prefix || prefix === '') return DEFAULT_LOCALE;
  return LOCALES.find((l) => l.pathPrefix === prefix) || null;
}

export function getLocaleByCode(code) {
  return LOCALES.find((l) => l.code === code) || DEFAULT_LOCALE;
}
